/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React from "react";
import "~/less/web-internal.less";
import { cls } from "cls";
import connectUserAndChat from "~/common/Store/connectUserAndChat";
import { User } from "~/common/Store/models/User";
import useKeymap from "~/shared/hooks/useKeymap";
import useLoggedInAs from "~/common/hooks/useLoggedInAs";
import { useRecentInternalNotesUpdate } from "./hooks/useRecentInternalNotesUpdate";
interface Props {
  showInternalNotesModal: boolean;
  toggleInternalNotesModal: () => void;
  user: User;
  itemNumber: string;
}
export const defaultInternalNotesData = {
  dateModified: "",
  userName: ""
};
const InternalNotesButton = connectUserAndChat(({
  showInternalNotesModal,
  toggleInternalNotesModal,
  user,
  itemNumber
}: Props) => {
  const showLoggedInAsBanner = useLoggedInAs(user);
  useKeymap({
    "alt+`": toggleInternalNotesModal
  });
  const isInternal = user.analyticsData?.is_on_vpn?.toLocaleUpperCase() === "YES";
  const loggedInAsBannerStyles = cls("bottom-[5.5rem]", "sm:bottom-[4.5rem]", "lg:bottom-2.5");
  const internalNotesRecentUpdate = useRecentInternalNotesUpdate(itemNumber, isInternal);
  const dateModifiedFormatted = internalNotesRecentUpdate.dateModified?.length ? new Date(internalNotesRecentUpdate.dateModified).toLocaleDateString("en-US", {
    month: "2-digit",
    day: "2-digit",
    year: "numeric"
  }) : "";
  return internalNotesRecentUpdate.dateModified?.length > 0 || internalNotesRecentUpdate.userName?.length > 0 ? <a type="button" onClick={toggleInternalNotesModal} id="web-internal-trigger" className={cls("webinfo-trigger", "webinfo-trigger--attention", "webinfo-trigger--expanded", showInternalNotesModal && "active", showLoggedInAsBanner && loggedInAsBannerStyles)} data-testid="show-internal-notes-button">
        <i className="icon-attention" />
        <span className="webinfo_heading">
          Internal Notes
          {(internalNotesRecentUpdate.userName?.length > 0 || internalNotesRecentUpdate.dateModified?.length > 0) && <span className="webinfo__meta">
              {dateModifiedFormatted?.length > 0 && <strong data-testid="internal-notes-date-updated">{`${dateModifiedFormatted} `}</strong>}
              {internalNotesRecentUpdate.userName?.length > 0 && <>
                  {"by "}
                  <strong data-testid="internal-notes-user-updated">
                    {internalNotesRecentUpdate.userName}
                  </strong>
                </>}
            </span>}
        </span>
      </a> : null;
});
export default InternalNotesButton;